import type { ReactNode } from "react";
import { ErrorTile } from "../../../../common/components/ErrorTile/ErrorTile";
import DownlineProfileIcon from "../../../../common/components/DownlineProfileLOS/DownlineProfileIcon";
import { KPI_ID } from "../../../../services/AboEnrichment/AboEnrichmentAPI.types";
import "./ProfileBanner.scss";

const PROFILE_BANNER_LINEAGE_KPIS = [KPI_ID.ABO_NAME, KPI_ID.PERSONAL_PV, KPI_ID.BONUS_PERCENT, KPI_ID.PHONE_NUMBER];

type Props = {
  aff: string;
  abo: string;
  imageRefUrl?: string;
  pushToHistory?: (affAbo: string) => void;
  isFetching: boolean;
  isError: boolean;
  refetch: () => unknown;
  customer?: boolean;
  basicInfo: ReactNode;
  contacts: ReactNode;
};

const ProfileBannerLayout = ({
  aff,
  abo,
  imageRefUrl,
  pushToHistory,
  isFetching,
  isError,
  refetch,
  customer = false,
  basicInfo,
  contacts,
}: Props) => {
  if (isError) {
    return (
      <div className="profileBanner">
        <ErrorTile
          errorStatus={isError}
          isLoading={isFetching}
          clickFunction={() => refetch()}
          tealiumTrackId="downline-profile-banner"
        />
      </div>
    );
  }
  return (
    <div className={`profileBanner${customer ? " profileBanner--customer" : ""}`}>
      <DownlineProfileIcon
        aff={aff}
        abo={abo}
        pushToHistory={pushToHistory}
        kpis={PROFILE_BANNER_LINEAGE_KPIS}
        imageRefUrl={imageRefUrl}
      />
      {basicInfo}
      <div className="profileBanner__spacer" aria-hidden="true"></div>
      {contacts}
    </div>
  );
};

export default ProfileBannerLayout;
